// Right column of the case brief: Assets and uncommon events (ticket 072, D2/D9). One stable
// component for every client. Order: Assets, Uncommon events, Data conflicts (old brief only).
import React from 'react'
import { SourceCardHeader } from './BriefParts'
import { DataConflictsCard } from './DataConflictsCard'
import { EventLines } from './EventLines'
import { RentalBusinessDetailCard } from './RentalBusinessDetailCard'
import { AutonomoCard } from './AutonomoCard'

export function AssetsColumn({ sections }) {
  const isIntake = sections.source === 'intake'
  const snapshotDone = sections.products.triage
  const link = (!isIntake && snapshotDone && sections.header.triagePublicToken)
    ? { href: `/spainsnapshot/results/${sections.header.triagePublicToken}`, label: 'View as client saw it ↗' }
    : null

  return (
    <div className="brief-col-context">
      <div className={`brief-source-card${isIntake || snapshotDone ? ' completed' : ''}`}>
        <SourceCardHeader title={isIntake ? 'Assets' : 'Spain Snapshot'} completed={!isIntake && snapshotDone} link={link} />
        <div className="brief-source-card-body">
          {!isIntake && !snapshotDone ? (
            <p className="brief-empty-note">Not completed yet.</p>
          ) : sections.assetFacts.length > 0 ? (
            // Label and value in table cells so every value lines up (ticket 072 feedback).
            <div className="brief-fact-group">
              {!isIntake && <div className="brief-fact-group-title">Assets</div>}
              <div className="brief-findings-wrap">
              <table className="brief-assets-table">
                <tbody>
                  {sections.assetFacts.map(({ label, value }) => (
                    <tr key={label} className="brief-assets-row">
                      <th scope="row" className="brief-assets-label">{label}</th>
                      <td className="brief-assets-value">{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          ) : (
            <p className="brief-empty-note">{isIntake ? 'No asset answers.' : 'No additional facts beyond the confirmed profile.'}</p>
          )}
        </div>
      </div>

      {sections.events.right.length > 0 && (
        <div className="brief-source-card">
          <SourceCardHeader title="Uncommon events" />
          <div className="brief-source-card-body">
            <EventLines events={sections.events.right} />
          </div>
        </div>
      )}

      {isIntake && <RentalBusinessDetailCard blocks={sections.intake.rentalBusiness} />}
      {isIntake && <AutonomoCard autonomo={sections.intake.autonomo} />}

      <DataConflictsCard conflicts={sections.dataConflicts} />
    </div>
  )
}
